"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipArrow = void 0;

var _colors = require("./colors");

var tooltipArrow = {
  colors: {
    default: {
      borderColor: _colors.colors.black
    }
  }
};
exports.tooltipArrow = tooltipArrow;